import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import ServicesSection from './components/ServicesSection';
import WhyChooseUs from './components/WhyChooseUs';
import ProcessSection from './components/ProcessSection';
import AboutSection from './components/AboutSection';
import TestimonialsSection from './components/TestimonialsSection';
import ServiceAreasSection from './components/ServiceAreasSection';
import SpecialOfferSection from './components/SpecialOfferSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import GallerySection from './components/GallerySection';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <TrustBar />
        <ServicesSection />
        <WhyChooseUs />
        <ProcessSection />
        <AboutSection />
        <TestimonialsSection />
        <ServiceAreasSection />
        <SpecialOfferSection />
        <FAQSection />
        <CTASection />
        <GallerySection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;